<!-- 登录 -->
<template>
<div class="loginCont">
  <!-- <div class="Idea">
    <p>从工业时代到信息时代，经历一个多世纪</p>
    <p class="tips">从传统软硬件到物联系统只需<span>一句代码</span></p>
    <img src="../../../../static/images/geeku_iot.png" alt="">
  </div> -->
  <div class="Login">
    <div class="loginIcon"><img src="../../../../static/images/logo.jpg" alt=""></div>
    <div class="title">
      <h1>全局平台</h1>
    </div>
    <div class="w-300" v-if="!isForget">
      <el-form ref="form" :model="form">
        <el-form-item>
          <el-input placeholder="账号" v-model="form.user_account">
            <!-- <i slot="prefix" class="ico ico-my"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="密码" type="password" @keyup.enter.native="login('form')" v-model="form.password">
            <!-- <i slot="prefix" class="ico ico-lock"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item>
          <div class="flexItem">
            <el-checkbox v-model="checked">记住账号</el-checkbox>
            <span class="forget" @click="isForget = true; forgetForm.user_account = form.user_account">忘记密码</span>
          </div>
        </el-form-item>
        <el-form-item class="mt60">
          <el-button class="login-button" type="primary" @click="login('form')">登录</el-button>
        </el-form-item>
        <!-- <el-form-item class="forgetItem clearfix">
          <span class="forget" @click="isForget = true; forgetForm.user_account = form.user_account">忘记密码</span>
        </el-form-item> -->
      </el-form>
    </div>

    <!-- 忘记密码 -->
    <div class="w-300" v-else>
      <el-form ref="form" :model="forgetForm">
        <el-form-item>
          <el-input placeholder="账号" v-model="forgetForm.user_account">
            <!-- <i slot="prefix" class="ico ico-my"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="邮箱" v-model="forgetForm.email">
            <!-- <i slot="prefix" class="ico ico-mail"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item>
          <div class="flexItem">
            <div> </div>
            <span class="forget" @click="isForget = false">返回登录</span>
          </div>
        </el-form-item>
        <el-form-item class="mt60">
          <el-button class="login-button" type="primary" @click="forgetPassword()">确认</el-button>
        </el-form-item>
        <!-- <el-form-item class="forgetItem clearfix">
          <span class="forget" @click="isForget = false">返回登陆</span>
        </el-form-item> -->
      </el-form>
    </div>

    <!--对话框-->
    <el-dialog
      :visible.sync="isSuccess">
      <div class="successBox">
        <p class="text">密码已发送到邮箱里，请查收</p>
        <!-- 确认清空忘记密码并隐藏输入框 -->
        <el-button type="primary" @click="isForget = false; isSuccess = false; forgetForm.user_account = {user_account: '',email: ''}">确 认</el-button>
      </div>
    </el-dialog>
    
  </div>
</div>
</template>

<script>
  import {
    localUserInfo,
    showToast,
    showLoading,
    hideLoading,
  } from '../../../../static/js/utility/utility.js'
  import { loginApi } from "../../../../static/js/api.js"

  export default {
    name: 'CLogin',
    data() {
      return {
        form: {
          user_account: '',
          password: ''
        },
        forgetForm: {
          user_account: '',
          email: ''
        },
        // 是否忘记密码
        isForget: false,
        // 密码是否发送成功
        isSuccess: false,

        checked:false,
      }
    },
    created: function () {
    },
    mounted(){
      
    },
    methods: {
      
      // 用户登录
      async login() {
        let vm = this
        console.log('输入内容：',vm.form)
        let data = vm.form
        showLoading('正在登录...')
        let res = await loginApi.userLogin(data)
        console.log('res: ',res)
        hideLoading()
        if (res.meta.code === 200) {
          showToast('登录成功')
          
          // localStorage存储用户token和用户名
          // localStorage.setItem('userInfo', JSON.stringify(res.data))
          localUserInfo.setItem(res.data)
          // 设置全局变量，供TopBar使用
          this.$store.state.userInfo = localUserInfo.getItem()
          // 登录成功，进入后台 (1为仪表盘，2为默认首页)
          let show_page = res.data.show_page, path = ''
          if (show_page === '1') {
            path = '/Map'
          } else {
            path = '/Index'
          }
          setTimeout(function () {
            vm.$router.push({
               path: path
            })
          }, 1000);
        } else {
          showToast(res.meta.message)
        }
      },
      // 忘记密码
      forgetPassword: async function () {
        console.log('修改信息', this.forgetForm)
        let forgetForm = this.forgetForm
        if (forgetForm.user_account === '') {
          showToast('请输入账号')
          return
        }
        if (forgetForm.email === '') {
          showToast('请输入邮箱')
          return
        }
        showLoading('重置密码中...')
        let res = await loginApi.forgetPassword(forgetForm)
        hideLoading()
        if (res.meta.code === 200) {
          this.isSuccess = true
        } else {
          showToast(res.meta.message)
        }
      }
    }
  }
</script>

<style lang="scss">
input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
	-webkit-text-fill-color: #666 !important;
	-webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color:transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
}
input {
	background-color:transparent;
}
.loginCont{
  height: 100vh;
  width: 100vw;
  background: url('../../../../static/images/loginBg.png') center center no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .Idea{
    position: absolute;
    right: 55.2%;
    top: 21.2%; 
    width: 340px;
    font-size: 18px;
    color: #fff;
    line-height: 26px;
    .tips{
      font-size: 30px;
      line-height: 32px;
      font-weight: bold;
      margin: 8px 0 30px;
      span{
        color: #2d83f4;
        margin-left: 30px;
      }
    }
  }
  .Login{
     width: 460px;
    margin-top: -5%;
    .loginIcon{
      width: 160px;
      height: 160px;
      border-radius: 50%;
      background: #fff;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 30px;
      img{
        width: 100%;
      }
    }
    .mt60{ margin-top: 60px; margin-bottom: 0px;}
    .el-input__inner{
      border: none;
      border-bottom: 2px solid #ccc;
      font-size: 24px;
      border-radius: 0;
      color: #666;
    }
    .ico{
      font-size: 25px;
      color: #333;
    }

  }
  h1 {
    font-size: 48px;
    color: #fff;
    margin: 60px 0 40px; 
    text-align: center;
    font-weight: normal;
  }
  .chooseTitle {
    text-align: center;
    color: aqua;
    font-size: 2em;
    margin: 50px;
  }
  .w-300 {
    width: 460px;
    border-radius: 10px;
    background-color: #fff;
    padding: 40px 30px;
  }
  .login-button {
    width: 100%;
    height: 58px;
    font-size: 24px;
    border-radius: 10px;
  }
  .notice {
    text-align: center;
  }

  .forgetItem {
    margin-bottom: 0;
  }

  .forgetForm .el-input {
    margin-bottom: 22px;
  }
  .flexItem{
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    .el-checkbox__inner{
      width: 18px;
      height: 18px;
      &::after{
        border:2px solid #fff;
        border-left: 0;
        border-top: 0;
        height: 9px;
        left: 5px;
        width: 4px;
      }
    }
    .el-checkbox__label{
      font-size: 18px;
    }
  }
  .forget,.back {
    font-size: 18px;
    color: #409EFF;
    text-decoration: underline;
  }
  // .back {
  //   display: block;
  //   width: 100%;
  //   font-size: 14px;
  //   line-height: 40px;
  //   text-align: right;
  //   margin-top: 22px;
  // }
  .successBox {
    text-align: center;
    .text{
      margin-bottom: 22px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/Login/Login.vue